import { Link } from "react-router-dom";
import { Shield, Phone, MessageCircle, MapPin, Mail, Facebook, Linkedin, Instagram, Globe } from "lucide-react";

export function Footer() {
  return (
    <footer className="bg-neutral-900 text-neutral-400 py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          {/* Brand */}
          <div className="col-span-1 md:col-span-1">
            <div className="flex items-center gap-3 mb-6 text-white">
              <Shield className="w-8 h-8" />
              <span className="text-xl font-bold">Portal Ethics</span>
            </div>
            <p className="text-sm leading-relaxed">
              Excelência em compliance, integridade e governança corporativa. 
              Transformando culturas organizacionais através da transparência.
            </p>
          </div>

          {/* Contato */}
          <div>
            <h6 className="text-white font-bold mb-6">Contato</h6>
            <ul className="space-y-4 text-sm">
              <li className="flex items-center gap-3">
                <Phone className="w-4 h-4 flex-shrink-0" />
                <span>(11) 9.888-90360</span>
              </li>
              <li className="flex items-center gap-3">
                <MessageCircle className="w-4 h-4 flex-shrink-0" />
                <span>(11) 9.8889-0360</span>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-4 h-4 flex-shrink-0" />
                <span>contato@etcs.com.br</span>
              </li>
            </ul>
          </div>

          {/* Onde Estamos */}
          <div>
            <h6 className="text-white font-bold mb-6">Onde Estamos</h6>
            <div className="flex items-start gap-3 text-sm">
              <MapPin className="w-4 h-4 flex-shrink-0 mt-1" />
              <p className="leading-relaxed">
                Avenida Paulista, 1106, Sala 1 - 16° Andar - Bela Vista, São Paulo - SP, 01.310-100
              </p>
            </div>
          </div>

          {/* Redes Sociais */}
          <div>
            <h6 className="text-white font-bold mb-6">Redes Sociais</h6>
            <div className="flex gap-4">
              <a 
                href="https://web.facebook.com/oficialethicscompliance?rdid=Rqc4WaES1nJDOEdK&share_url=https%3A%2F%2Fweb.facebook.com%2Fshare%2F15g5UBMuPL%2F%3F_rdc%3D1%26_rdr#" 
                target="_blank" 
                rel="noopener noreferrer"
                className="hover:text-white transition-colors"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a 
                href="https://www.linkedin.com/company/ethics-compliance-oficial/?viewAsMember=true" 
                target="_blank" 
                rel="noopener noreferrer"
                className="hover:text-white transition-colors"
              >
                <Linkedin className="w-5 h-5" />
              </a>
              <a 
                href="https://www.instagram.com/ethicscompliance_?igsh=MW9iMGQ1YmloY3Y1cg%3D%3D" 
                target="_blank" 
                rel="noopener noreferrer"
                className="hover:text-white transition-colors"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a 
                href="https://www.etcs.com.br/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="hover:text-white transition-colors"
                title="Website"
              >
                <Globe className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-white/5 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs">
          <p>&copy; 2024 Portal Ethics. Todos os direitos reservados.</p>
          <div className="flex gap-6">
            <Link to="/politicas#privacidade" className="hover:text-white">Privacidade</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}